import Vue from 'vue';

Vue.filter('toString', value => value.toString());
Vue.filter('truncate', function(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = '...';
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
});
